import BlockExpandableTabStandard from '../BlockExpandableTab/BlockExpandableTabStandard.vue';
export default defineComponent({
  name: 'BlockTabsContainerVertical',
  components: {
    BlockExpandableTabStandard: BlockExpandableTabStandard
  },
  props: {
    title: String,
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabTitle: String,
    catchphrase: String,
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var getDataFromTab = function getDataFromTab(tab, type) {
      var _tab$fields, _tab$fields$image, _tab$fields$image$fie;
      if (tab.fields) {
        switch (type) {
          case 'img':
            return (_tab$fields = tab.fields) === null || _tab$fields === void 0 ? void 0 : (_tab$fields$image = _tab$fields.image) === null || _tab$fields$image === void 0 ? void 0 : (_tab$fields$image$fie = _tab$fields$image.fields) === null || _tab$fields$image$fie === void 0 ? void 0 : _tab$fields$image$fie.file;
        }
      }
      return null;
    };
    var getTitle = function getTitle(tab) {
      var _tab$fields2;
      return tab === null || tab === void 0 ? void 0 : (_tab$fields2 = tab.fields) === null || _tab$fields2 === void 0 ? void 0 : _tab$fields2.title;
    };
    var getContent = function getContent(tab) {
      var _tab$fields3;
      return tab === null || tab === void 0 ? void 0 : (_tab$fields3 = tab.fields) === null || _tab$fields3 === void 0 ? void 0 : _tab$fields3.contents;
    };
    return {
      getDataFromTab: getDataFromTab,
      getContent: getContent,
      getTitle: getTitle
    };
  }
});